import { render, staticRenderFns } from "./QuarterlySlideViewer.vue?vue&type=template&id=0474d009&scoped=true&"
import script from "./QuarterlySlideViewer.vue?vue&type=script&lang=js&"
export * from "./QuarterlySlideViewer.vue?vue&type=script&lang=js&"
import style0 from "./QuarterlySlideViewer.vue?vue&type=style&index=0&id=0474d009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474d009",
  null
  
)

export default component.exports